<template>
  <div class="homelatest">
    <div class="comp-title ml-2">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Mới phát hành
        </h1>
      </div>
    </div>

    <div style="clear:both;"></div>

    <div class="content ml-1">
      <div v-for="item in dataList" class="item mb-4">
        <a :href="prefixSong + item.id + '/' + convertToAlias(item.song)">
          <img class="thumbnail" :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail"/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <p class="singer color-text">{{ item.singer }}</p>
          <p class="viewcount font-size-13 color-text mr-1"><span class="fa fa-headphones"></span> {{ item.viewscountWeb }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Latest",
    data () {
      return {
        prefixSong: this.settings.prefixSong,
        defaultThumbnail: this.settings.defaultThumbnailSong,
        dataList: [
          {
            "id": 1,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "viewCount": "20.000",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 2,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "viewCount": "20.000",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 3,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "viewCount": "20.000",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 4,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "viewCount": "20.000",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 5,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "viewCount": "20.000",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          }
        ]
      }
    },
    methods: {
      getListSong(){
        axios.post(api.latest, {pageSize: 5})
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("Latest---");
            console.log(e);
          });
      }
    },
    watch: {
      "$route.path": {
        handler: "getListSong",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .content{
    margin-top: 10px !important;
    text-align: left;
  }
  .thumbnail{
    float: left;
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .item{
    position: relative;
  }
  .viewcount{
    position: absolute;
    top: 0.5rem;
    right: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/wap/Latest.vue